import Views from '../../views/host/hostRegistration/HostRegistrationViews';
import getInitialStateOmeRoute from './GetInitialStateOmeRoute';
import getInitialStateMeetRoute from './GetInitialStateMeetRoute';
import {
  eligibilityIsComplete, meetInfoIsComplete, restrictionsIsComplete,
  sessionsIsComplete, ageGroupsIsComplete, timeStandardsIsComplete
} from './LeftNavValidation';

const getTimeStandards = (viewName, route, omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, restrictionsRoutePermission, eligibilityRoutePermission, meetInfoRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION) => {
  const isCurrent = viewName === Views.OME_MEET_TIME_STANDARDS;

  const isMeetInfoComplete = meetInfoIsComplete(omeMeetStateObjData, meetStateObjData, omeMeetEntryStateObjData, meetInfoRoutePermission);
  const isEligibilityComplete = eligibilityIsComplete(omeMeetStateObjData, omeMeetEntryStateObjData, eligibilityRoutePermission, HIDE_OME_ELIGIBILITY_50_BONUS_OPTION);
  const isRestrictionsComplete = restrictionsIsComplete(omeMeetStateObjData, restrictionsRoutePermission);
  const isSessionsComplete = sessionsIsComplete(meetStateObjData);
  const isAgeGroupsComplete = ageGroupsIsComplete(omeMeetStateObjData);

  const isComplete = timeStandardsIsComplete(omeMeetStateObjData) === true && isMeetInfoComplete === true && isEligibilityComplete === true && isAgeGroupsComplete === true &&
    isRestrictionsComplete === true && isSessionsComplete === true;

  const arePrerequisitesDone = isMeetInfoComplete === true && isEligibilityComplete === true
    && isRestrictionsComplete === true && isSessionsComplete === true
    && isAgeGroupsComplete === true;

  const item = route === '' ? getInitialStateOmeRoute(Views.OME_MEET_TIME_STANDARDS) : getInitialStateMeetRoute(Views.OME_MEET_TIME_STANDARDS);

  return {
    ...item,
    isCurrent,
    isComplete,
    arePrerequisitesDone
  };
};

export default getTimeStandards;